export { default as Paul } from './Paul';
export { default as Ahmad } from './Ahmad';
export { default as Christopher } from './Christopher';
export { default as Khoo } from './Khoo';
export { default as OurTeam } from './OurTeam';



// WEBPACK FOOTER //
// ./src/screens/OurTeam/index.js